<template>
  <div class="min-h-screen bg-gray-100">
    <TopBar
      v-if="userData && role"
      :role="role"
      :user-data="userData.data"
      :menu-items="teacherMenuComputed"
      :mobile-menu-items="teacherMenuComputed"
      :institutions="institutions"
      :selected-institution-id="selectedInstitutionId"
      @institution-change="handleInstitutionChange"
    />
    <main class="max-w-[1300px] m-auto py-4 px-2 sm:px-4">
      <router-view />
    </main>
  </div>
</template>

<script>
import TopBar from "@/views/V2/dashboard/components/TopBar.vue";
import { getMyInstitutions } from "@/services/institutions.service";

export default {
  name: "TeacherLayout",
  components: {
    TopBar,
  },
  data() {
    return {
      role: null,
      userData: null,
      institutions: [],
      selectedInstitutionId: null,
      teacherMenu: [
        {
          label: "Mis grupos",
          icon: "codicon:mortar-board",
          iconHeight: "22",
          link: "/teacher/groups",
        },
        {
          label: "Solicitudes",
          icon: "ph:envelope-simple",
          iconHeight: "22",
          link: "/teacher/requests",
        },
      ],
    };
  },
  computed: {
    hasInstitutions() {
      return Array.isArray(this.institutions) && this.institutions.length > 0;
    },
    teacherMenuComputed() {
      if (this.role === "ROLE_ACADEMIC_ADMIN" && !this.hasInstitutions) {
        return this.teacherMenu.filter((item) => item.link !== "/teacher/groups");
      }
      return this.teacherMenu;
    },
  },
  methods: {
    async loadInstitutions({ forceRefresh = false } = {}) {
      const stored = JSON.parse(localStorage.getItem("teacher_institutions") || "[]");
      if (!forceRefresh && Array.isArray(stored) && stored.length > 0) {
        this.institutions = stored;
        return;
      }
      try {
        const list = await getMyInstitutions();
        if (Array.isArray(list) && list.length > 0) {
          this.institutions = list;
          localStorage.setItem("teacher_institutions", JSON.stringify(list));
        } else {
          // API succeeded but no institutions (empty DB or user not linked to any)
          this.institutions = [];
          localStorage.setItem("teacher_institutions", "[]");
          localStorage.removeItem("teacher_current_institution_id");
          this.selectedInstitutionId = null;
        }
      } catch {
        // API failed (network, auth, etc.): use stored or show empty
        this.institutions = Array.isArray(stored) ? stored : [];
      }
    },
    loadSelectedInstitution() {
      const storedId = localStorage.getItem("teacher_current_institution_id");
      this.selectedInstitutionId = storedId ? Number(storedId) : null;
      if (!this.selectedInstitutionId && this.institutions.length === 1) {
        this.selectedInstitutionId = this.institutions[0].id;
        localStorage.setItem("teacher_current_institution_id", this.selectedInstitutionId);
      }
    },
    handleInstitutionChange(institutionId) {
      if (!institutionId) {
        return;
      }
      this.selectedInstitutionId = institutionId;
      localStorage.setItem("teacher_current_institution_id", institutionId);
      this.$root.$emit("teacher-institution-change", institutionId);
    },
    handleInstitutionsUpdated(institutions) {
      this.institutions = Array.isArray(institutions) ? institutions : [];
      localStorage.setItem("teacher_institutions", JSON.stringify(this.institutions));

      const activeInstitutions = this.institutions.filter(
        (institution) => institution.active !== false
      );
      const currentId = this.selectedInstitutionId;
      const stillValid = activeInstitutions.some(
        (institution) => String(institution.id) === String(currentId)
      );

      if (!stillValid) {
        const nextId = activeInstitutions.length ? activeInstitutions[0].id : null;
        this.selectedInstitutionId = nextId;
        if (nextId) {
          localStorage.setItem("teacher_current_institution_id", nextId);
          this.$root.$emit("teacher-institution-change", nextId);
        } else {
          localStorage.removeItem("teacher_current_institution_id");
        }
      }
    },
  },
  async mounted() {
    this.role = window.localStorage.getItem("role");
    this.userData = JSON.parse(window.localStorage.getItem("auth"));
    await this.loadInstitutions();
    this.loadSelectedInstitution();
    import("../../../assets/css/styles-v2.css");
    this.$root.$on("teacher-institutions-updated", this.handleInstitutionsUpdated);
    if (this.role === "ROLE_ACADEMIC_ADMIN" && !this.hasInstitutions) {
      this.$router.push("/teacher/institutions").catch(() => {});
    }
  },
  beforeDestroy() {
    this.$root.$off("teacher-institutions-updated", this.handleInstitutionsUpdated);
  },
};
</script>
